
import NotificationList from './components/NotificationList';


function App() {
  return (
    <div>
     <NotificationList/>
    </div>
  );
}

export default App;
